<template>
  <div>
    <!-- <v-card elevation="6" v-if="event == null">
      {{ eventId }} - {{ JSON.stringify(event) }}
    </v-card> -->
    <v-card
      elevation="6"
      :class="GetCellClass(event)"
    v-if="event && Array.isArray(event.risorseIntervento) && event.risorseIntervento.length > 0"
      style="height: min-content"
    >
      <v-card-title class="title">
        <v-col class="text-center">
          <h3 class="text-center">
            {{ event != null ? event.descrizione : "---" }}
          </h3>
        </v-col>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-4">
        <v-row>
          <v-col sm="6" style="margin-top: 10px">
            <h3>Cliente:</h3>
            {{
              event != null
                ? event.cliente != null
                  ? event.cliente?.descrizione
                  : "---"
                : "---"
            }}
          </v-col>
        </v-row>

        <!-- <h3>Cliente:</h3> -->
        <v-row>
          <v-col sm="10" style="margin-top: 10px">
            <h3>Indirizzo:</h3>
            {{ event != null ? event.indirizzoCompleto : "---" }}
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="6" style="margin-top: 10px">
            <h3>Commessa:</h3>
            {{
              event != null
                ? event.commessa != null
                  ? event.commessa.descrizione != ""
                    ? event.commessa.descrizione
                    : "   -------------"
                  : "   -------------"
                : "   -------------"
            }}
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="6" style="margin-top: 10px">
            <h3>Operatori:</h3>
            <div
              class="font-weight-medium"
              v-for="mezzo in workers"
              :key="mezzo.idRisorsa"
            >
              {{ mezzo != null ? mezzo.descrizione : "---" }}
            </div>
          </v-col>
          <v-col sm="6" style="margin-top: 10px">
            <h3>Mezzi:</h3>
            <div
              class="font-weight-medium"
              v-for="res in vehicles"
              :key="res.idRisorsa"
            >
              {{ res != null ? res.descrizione : "---" }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="12" style="margin-top: 10px">
            <h3>Attrezzature:</h3>
            <div
              class="font-weight-medium"
              v-for="res in equipments"
              :key="res.idRisorsa"
            >
              {{ res != null ? res.descrizione : "---" }}
            </div>
          </v-col>
          <v-col sm="12" style="margin-top: 10px">
            <h3>Note:</h3>

            <div>
              {{ event != null ? event.note : "" }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider style="margin-top: 10px"></v-divider>
      <v-card-actions>
        <v-row>
          <v-col
            v-if="event?.creatore != null"
            style="margin-top: 10px; margin-bottom: 10px"
          >
            <span>
              <v-avatar
                :color="
                  event?.creatore.color != null ? event?.creatore.color : '#777'
                "
                size="26"
                ><v-icon dark> mdi-account-circle </v-icon>
              </v-avatar>
              {{ this.event?.creatore.username }}
            </span>
          </v-col>
          <v-col style="margin-top: 10px; margin-bottom: 10px">
            <span>
              <v-icon>mdi-calendar</v-icon>
              <span v-if="event?.giornoIntero">Tutto il giorno</span>
              <span v-if="!event?.giornoIntero"
                >{{ moment(event?.inizio).format("HH:mm") }} -
                {{ moment(event?.fine).format("HH:mm") }}</span
              >
            </span>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
// import func from 'vue-editor-bridge';
import EasyPlanClient from "../../utils/EasyPlanClient";
import moment from "moment";
export default {
  data: function () {
    return {
      event: null,
    };
  },
  props: {
    eventId: null,
    forceUpdate: { type: Boolean, default: false },
  },
  watch: {
    forceUpdate(old, newVal) {
      console.debug("AGGIORNOOO");
      this.loadEvent(this.eventId, (ev) => {
        console.debug("evento", ev);
        this.event = ev;
        if (this.workers.length > 0) {
          console.debug("eventoId", ev.idIntervento);
          console.debug("workers", this.workers);
          console.debug("equi", this.equipments);
          console.debug("vehic", this.vehicles);
        }
      });
    },
  },
  computed: {
    vehicles() {
      if (this.event != null)
        return this.event.risorseIntervento
          .filter((r) => r.risorsa.tipo == "Mezzo")
          .map((ri) => ri.risorsa);
      else return [];
    },
    workers() {
      
      if (this.event != null)
      return this.event.risorseIntervento
        .filter((r) => r.risorsa.tipo == "Uomo")
        .map((ri) => ri.risorsa);
        else 
        return [];
    },
    equipments() {
      
      if (this.event != null)
      return this.event.risorseIntervento
        .filter((r) => r.risorsa.tipo == "Attrezzatura")
        .map((ri) => ri.risorsa);
        else
        return [];
    },
  },
  methods: {
    moment: moment,
    loadEvent(eventId, callback) {
      EasyPlanClient.Event.Find(this.$route.params.companyAlias, eventId)
        .then((res) => {
          try {
            if (res != undefined && res != null) {
              if (res.data != null) {
                this.event = res?.data?.data;
                if (this.event) {
                  console.log(this.event);
                  this.event.risorse = [];
                  //le risorse vengono gestite come risorse dai vari stepper coinvolti, quindi per eventi già esistenti, per far selezionare correttamente le checkbox, bisogna ricaricare le cose
                  this.event.risorseIntervento.forEach((element) => {
                    this.event.risorse.push(element.risorsa);
                  });
                  callback(this.event);
                }
              }
            }
          } catch (err) {
            console.error(err);
          }
          // this.dialog = true;
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error?.response?.data?.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error?.response?.data?.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
    getFullAddress(address, city, province) {
      let fullAddress = ""; //address + " - " + city + " (" + province + ") ";
      if (address != null) fullAddress += address;
      if (city != null) fullAddress += " - " + city;
      if (province != null) fullAddress += " (" + province + ")";

      return fullAddress;
    },
    GetCellClass(ev) {
      if (ev != null)
        // if (this.selectedItems.find((i) => i.id == itemId) != undefined)
        //   return "primary";
        return ev.lampeggia == "true" ? "blink event" : "event";
      else return "event";
    },
  },
  created() {
    console.debug("evid", this.eventId);
    let t = this;
 t.loadEvent(this.eventId, (ev) => {
        if (ev != null) {
          console.debug("evento", ev);
          console.debug("eventoId", ev.idIntervento);
          if (JSON.stringify(ev) != JSON.stringify(t.event)) {
            t.event = ev;
            if (this.workers.length > 0) {
              console.debug("workers", this.workers);
              console.debug("equi", this.equipments);
              console.debug("vehic", this.vehicles);
            }
          }
        }
      });
    setInterval(() => {
      t.loadEvent(this.eventId, (ev) => {
        if (ev != null) {
          console.debug("evento", ev);
          console.debug("eventoId", ev.idIntervento);
          if (JSON.stringify(ev) != JSON.stringify(t.event)) {
            t.event = ev;
            if (this.workers.length > 0) {
              console.debug("workers", this.workers);
              console.debug("equi", this.equipments);
              console.debug("vehic", this.vehicles);
            }
          }
        }
      });
    }, 60000);
  },
};
</script>

<style>
.event .col {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.title {
  padding: 5px 0px !important;
}
</style>
